import type { ReactNode } from 'react';
import React from 'react';

import * as styles from '../styles/SimpleModalBody.styles';

export interface SimpleModalBodyProps {
  children: ReactNode;
}

export const SimpleModalBody = ({ children }: SimpleModalBodyProps) => (
  <div css={styles.container}>{children}</div>
);
